module.exports = __webpack_public_path__ + "img/Tris.28a9ca17.png";